import React from 'react'

export function Button({ 
  children, 
  className = '', 
  variant = 'primary',
  size = 'md',
  ...props 
}) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-bold transition-all duration-300 relative overflow-hidden group focus:outline-none focus:ring-2 focus:ring-electric-blue/50'
  
  const variants = {
    // Deep Tech Noir variants following design specifications
    primary: 'bg-electric-gradient text-deep-charcoal hover:shadow-electric font-heading border-2 border-transparent hover:scale-105',
    secondary: 'bg-deep-navy/80 text-bright-white border-2 border-electric-blue/30 hover:bg-deep-navy/60 hover:border-electric-blue/50 backdrop-blur-sm',
    outline: 'border-2 border-electric-blue/70 text-electric-blue hover:bg-electric-blue/10 backdrop-blur-md hover:shadow-interactive',
    tech: 'bg-deep-charcoal border-2 border-electric-blue/50 text-electric-blue hover:bg-electric-blue hover:text-deep-charcoal hover:shadow-electric',
    ghost: 'text-subtle-gray hover:text-bright-white hover:bg-deep-navy/50 backdrop-blur-sm',
    // Legacy variants for backwards compatibility
    electric: 'bg-gradient-to-r from-electric-500 to-tech-cyan text-white hover:shadow-electric',
  }
  
  const sizes = {
    sm: 'px-4 py-2 text-sm tracking-wide',
    md: 'px-6 py-3 text-base tracking-wide',
    lg: 'px-10 py-5 text-lg tracking-wider'
  }
  
  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      <span className="relative z-10 flex items-center font-heading uppercase">
        {children}
      </span>
      {/* Hover effect overlay for interactivity */}
      <div className="absolute inset-0 bg-gradient-to-r from-bright-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
    </button>
  )
}